var _rect, _rect2, _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLbLogoSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 40,
    viewBox: "0 0 75 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74.717,
    height: 40,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0629,
    y: 6.91797,
    width: 26.1635,
    height: 26.1635,
    rx: 6.65563,
    fill: "#DCFAD2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12818_148776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5046 16.1628C20.5322 16.1508 20.5598 16.1391 20.5875 16.1278L26.9539 13.1428L32.5122 16.5481L31.5338 23.0183L20.6672 28.1133L19.0305 24.584L18.7639 24.0487C16.8013 23.6802 14.6385 22.6219 11.9962 20.178L16.0803 18.2497C15.6281 16.2743 16.1128 14.1628 17.4556 12.5727L18.382 11.4756L20.5046 16.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8561 17.8741C26.6486 18.5482 27.0234 19.265 27.6932 19.475C28.363 19.6851 29.0742 19.3089 29.2817 18.6348C29.4892 17.9607 29.1144 17.244 28.4446 17.0339C27.7747 16.8238 27.0636 17.2 26.8561 17.8741ZM28.4941 18.2848C28.5002 18.2925 28.506 18.3003 28.5115 18.3083C28.5367 18.0971 28.4095 17.8914 28.2008 17.8259C27.9659 17.7522 27.7161 17.8841 27.6432 18.121C27.5929 18.2846 27.6402 18.4553 27.7518 18.5694C27.7449 18.4386 27.7988 18.3064 27.9083 18.2184C28.0884 18.0737 28.3507 18.1034 28.4941 18.2848Z",
    fill: "#00322E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4555 12.5717L18.382 11.4746L20.5046 16.1619C20.5319 16.15 20.5593 16.1384 20.5867 16.1272L26.9539 13.1419L32.5122 16.5472L32.2015 18.6021L33.4719 19.3704C33.6072 19.4522 33.5724 19.6584 33.4178 19.6907L32.4687 19.8893L33.1774 20.3179C33.3127 20.3997 33.2779 20.6059 33.1233 20.6383L31.8534 20.9039L31.5338 23.0174L25.7713 25.7192L27.0548 28.5567H25.6961L24.6503 26.2448L24.0746 26.5147L24.9983 28.5567H23.6395L22.9536 27.0403L20.6672 28.1123L18.7839 24.0516C17.0738 23.7344 15.2122 22.8945 13.0138 21.0705C12.6824 20.7956 12.3434 20.4983 11.9962 20.1771L16.0802 18.2488C15.6281 16.2734 16.1127 14.1619 17.4555 12.5717ZM19.3842 16.6889L18.7261 16.9996L17.2313 17.7005C16.9957 16.3524 17.2898 14.9479 18.076 13.7999L19.3842 16.6889ZM19.2504 18.126L14.2608 20.4818C14.532 20.6937 14.7962 20.8883 15.0536 21.0669C15.084 21.0769 15.1139 21.0895 15.1432 21.1046C16.9727 22.0499 18.8569 21.3946 19.9103 20.2322C20.1403 19.9783 20.5314 19.96 20.7839 20.1913C21.0363 20.4226 21.0545 20.8159 20.8245 21.0697C20.1695 21.7926 19.2569 22.3724 18.2176 22.6407C19.4961 23.0119 20.6749 23.0247 21.8999 22.8919C23.4494 22.7239 24.6714 21.2092 24.5649 19.5059C24.4552 17.7501 22.6747 16.6369 21.0771 17.2695L19.2504 18.126ZM23.4758 16.1448C24.7384 16.679 25.703 17.8865 25.7993 19.4278C25.9429 21.7243 24.3078 23.8817 22.0326 24.1284C21.4358 24.1931 20.835 24.2272 20.2204 24.2063L21.2654 26.4597L30.4106 22.1718L31.1657 17.1785L26.8761 14.5505L23.4758 16.1448Z",
    fill: "#00322E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2525 12.5015C50.1112 12.4522 50.9688 12.4561 51.8275 12.4561C51.8334 12.4561 56.1784 12.4561 56.1784 12.4561C57.0538 12.4561 57.9114 12.4522 58.7696 12.5015C59.5498 12.5459 60.3097 12.6407 61.0662 12.8524C62.6586 13.2975 64.0492 14.2272 65.0544 15.5452C66.0537 16.8549 66.5945 18.4582 66.5945 20.1044C66.5945 21.7526 66.0537 23.3549 65.0544 24.6645C64.0492 25.9821 62.6586 26.9123 61.0662 27.3574C60.3097 27.5691 59.5498 27.6634 58.7696 27.7083C57.9114 27.7576 57.0538 27.7532 56.1952 27.7532C56.1892 27.7532 51.8433 27.7537 51.8433 27.7537C50.9688 27.7532 50.1112 27.7576 49.2525 27.7083C48.4729 27.6634 47.7129 27.5691 46.9564 27.3574C45.364 26.9123 43.9734 25.9821 42.9682 24.6645C41.9689 23.3549 41.4276 21.7526 41.4276 20.1049C41.4276 18.4582 41.9689 16.8549 42.9682 15.5452C43.9734 14.2272 45.364 13.2975 46.9564 12.8524C47.7129 12.6407 48.4729 12.5459 49.2525 12.5015Z",
    fill: "#34C759"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_12818_148776)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9458 26.767C62.625 26.767 65.6076 23.7844 65.6076 20.1052C65.6076 16.426 62.625 13.4434 58.9458 13.4434C55.2665 13.4434 52.2839 16.426 52.2839 20.1052C52.2839 23.7844 55.2665 26.767 58.9458 26.767Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_12818_148776",
    x: 48.3362,
    y: 10.976,
    width: 21.2192,
    height: 21.2187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.48041
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.246734
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12818_148776"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.48041
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.97388
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_12818_148776",
    result: "effect2_dropShadow_12818_148776"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12818_148776",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12818_148776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.3403,
    height: 17.1145,
    fill: "white",
    transform: "translate(11.9745 11.4424)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLbLogoSwitch);
export default __webpack_public_path__ + "static/media/lb-logo-switch.d6dc978655e6e68c4dfff686a502c4c9.svg";
export { ForwardRef as ReactComponent };